import { addNotification, fetchNotifications } from "../redux/actions/notificationActions";
import store from "../redux/store";
import config from "../config";

const MAX_RECONNECT_DELAY_MS = 30000;
// server closes with this code when the token is invalid/expired
const INVALID_TOKEN_CLOSE_CODE = 4401;

let socket = null;
let reconnectTimeoutId = null;
let reconnectAttempts = 0;
let currentToken = null;

// exponential backoff, capped, so a dropped connection doesn't hammer the server
const getReconnectDelay = () => Math.min(1000 * 2 ** reconnectAttempts, MAX_RECONNECT_DELAY_MS);

const connect = (token) => {
    socket = new WebSocket(`${config.wsUrl}/ws/notifications/?token=${encodeURIComponent(token)}`);

    socket.onopen = () => {
        console.log("Notification websocket connected");
        reconnectAttempts = 0;
        // pushes made while Redis was down are only saved in the db, so resync on every (re)connect
        store.dispatch(fetchNotifications(token));
    }

    socket.onmessage = (event) => {
        const data = JSON.parse(event.data)
        store.dispatch(addNotification(data));
    };

    socket.onerror = (error) => {
        console.error("Notification websocket error", error);
    }

    socket.onclose = (event) => {
        console.log("notification websocket closed", event.code);
        socket = null;
        // an invalid token will keep failing the same way, so don't loop on it
        if (event.code === INVALID_TOKEN_CLOSE_CODE) return;
        reconnectTimeoutId = setTimeout(() => {
            reconnectTimeoutId = null;
            connect(token);
        }, getReconnectDelay());
        reconnectAttempts += 1;
    }
}

export const ConnectNotificationSocket = (token) => {
    if (!token) return;
    if (socket && currentToken === token) return;

    // cancel any pending auto-reconnect and drop a stale connection before reconnecting with the new token
    if (reconnectTimeoutId) {
        clearTimeout(reconnectTimeoutId);
        reconnectTimeoutId = null;
    }
    if (socket) {
        socket.onclose = null;
        socket.close();
        socket = null;
    }

    reconnectAttempts = 0;
    currentToken = token;
    connect(token);
}